"use client";

import { ProductCard, type ProductCardProps } from "@/features/products/ProductCard/ProductCard";
import { useCampaignTagsForProduct } from "./hooks";

type ProductCardWithCampaignsProps = Omit<ProductCardProps, "campaignTags">;

export const ProductCardWithCampaigns = (props: ProductCardWithCampaignsProps) => {
	const campaignTags = useCampaignTagsForProduct(props.product);
	
	return <ProductCard {...props} campaignTags={campaignTags} />;
};